import { Injectable, signal, inject } from '@angular/core';
import { StorageService } from '../shared/storage.service';

export type ViewMode = 'list' | 'table';

const VIEW_MODE_TRANSACTIONS_STORAGE_KEY = 'superpay_view_mode_transactions';
const VIEW_MODE_PAYMENTS_STORAGE_KEY = 'superpay_view_mode_payments';

@Injectable({
  providedIn: 'root'
})
export class ViewModeStore {
  private storageService = inject(StorageService);
  
  // Signals separados para transactions y payments
  private _transactionsViewMode = signal<ViewMode>(this.loadViewMode(VIEW_MODE_TRANSACTIONS_STORAGE_KEY));
  private _paymentsViewMode = signal<ViewMode>(this.loadViewMode(VIEW_MODE_PAYMENTS_STORAGE_KEY));

  // Public read-only signals
  transactionsViewMode = this._transactionsViewMode.asReadonly();
  paymentsViewMode = this._paymentsViewMode.asReadonly();

  private loadViewMode(key: string): ViewMode {
    const stored = this.storageService.get<ViewMode>(key);
    return stored || 'list';
  }

  // Métodos para Transactions
  toggleTransactionsViewMode() {
    const newMode = this._transactionsViewMode() === 'list' ? 'table' : 'list';
    this._transactionsViewMode.set(newMode);
    this.storageService.save(VIEW_MODE_TRANSACTIONS_STORAGE_KEY, newMode);
  }

  setTransactionsViewMode(mode: ViewMode) {
    this._transactionsViewMode.set(mode);
    this.storageService.save(VIEW_MODE_TRANSACTIONS_STORAGE_KEY, mode);
  }

  isTransactionsTableView() {
    return this._transactionsViewMode() === 'table';
  }

  isTransactionsListView() {
    return this._transactionsViewMode() === 'list';
  }

  // Métodos para Payments
  togglePaymentsViewMode() {
    const newMode = this._paymentsViewMode() === 'list' ? 'table' : 'list';
    this._paymentsViewMode.set(newMode);
    this.storageService.save(VIEW_MODE_PAYMENTS_STORAGE_KEY, newMode);
  }

  setPaymentsViewMode(mode: ViewMode) {
    this._paymentsViewMode.set(mode);
    this.storageService.save(VIEW_MODE_PAYMENTS_STORAGE_KEY, mode);
  }

  isPaymentsTableView() {
    return this._paymentsViewMode() === 'table';
  }

  isPaymentsListView() {
    return this._paymentsViewMode() === 'list';
  }
}
